<script lang="ts">
	import { onMount } from 'svelte';
	import { Splide, SplideSlide } from '@splidejs/svelte-splide';
	import '@splidejs/svelte-splide/css';

	let items: any[] = [];
	let popupModal = false;
	let isMobile = false;

	onMount(async () => {
		isMobile = window.innerWidth <= 768;

		// Ambil country dari cookie atau dari IP API
		let country = getCookie('country');

		if (!country) {
			try {
				const res = await fetch('https://ipapi.co/json');
				const data = await res.json();
				country = data.country_name || 'OTHER';

				// Simpan ke cookie (optional, expired in 1 day)
				document.cookie = `country=${country}; path=/; max-age=${60 * 60 * 24}`;
			} catch (error) {
				console.error('Gagal mengambil lokasi:', error);
				country = 'OTHER';
			}
		}

		// Ambil data popup dari API
		try {
			const res = await fetch(
				`https://www.transresortbali.com/cms/api/v1/popup?country=${country}`
			);
			const data = await res.json();
			items = data?.data || [];
		} catch (error) {
			console.error('Gagal mengambil popup:', error);
		}

		// Show modal jika belum ditampilkan sebelumnya
		if (!sessionStorage.getItem('popupShown') && items.length > 0) {
			setTimeout(() => {
				if (isMobile) {
					popupModal = true;
				} else {
					if ('requestIdleCallback' in window) {
						requestIdleCallback(() => {
							popupModal = true;
						});
					} else {
						popupModal = true;
					}
				}
				sessionStorage.setItem('popupShown', 'true');
			}, 5000);
		}
	});

	function getCookie(name: string) {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		if (parts.length === 2) return parts.pop()?.split(';').shift();
	}
	function closeModal() {
		popupModal = false;
	}
</script>

<!-- Render pop-up jika kondisi terpenuhi -->
{#if popupModal && items.length > 0}
	<div tabindex="-1" class="fixed inset-0 z-50 flex justify-center items-center">
		<div class="absolute w-full h-full bg-black/30"></div>
		<div class="relative w-full max-w-2xl max-h-full bg-white rounded-lg shadow dark:bg-gray-700">
			<!-- Close button -->
			<button
				type="button"
				class="absolute top-3 right-2.5 bg-gray-200 text-gray-900 rounded-lg text-sm w-8 h-8 inline-flex justify-center items-center"
				on:click={closeModal}
				style="z-index: 1;"
			>
				<svg
					class="w-3 h-3"
					aria-hidden="true"
					xmlns="http://www.w3.org/2000/svg"
					fill="none"
					viewBox="0 0 14 14"
				>
					<path
						stroke="currentColor"
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
					/>
				</svg>
				<span class="sr-only">Close modal</span>
			</button>

			<!-- Desktop Pop-up -->
			<div class="hidden md:block">
				<Splide
					options={{
						rewind: false,
						gap: 5,
						perPage: 1,
						type: 'slide',
						arrows: false,
						pagination: false,
						autoplay: true,
						interval: 3000,
						pauseOnHover: false
					}}
				>
					{#each items as item}
						{#each item.images_desktop as img}
							<SplideSlide>
								<a href={item?.url_desktop} aria-label="pop up">
									<img class="w-full" src={img?.path} alt={img?.path} loading="lazy" />
								</a>
							</SplideSlide>
						{/each}
					{/each}
				</Splide>
			</div>

			<!-- Mobile Pop-up -->
			<div class="block md:hidden">
				<Splide
					options={{
						rewind: false,
						gap: 5,
						perPage: 1,
						type: 'slide',
						arrows: false,
						pagination: false,
						autoplay: true,
						interval: 3000,
						pauseOnHover: false
					}}
				>
					{#each items as item}
						{#each item.images_mobile as img}
							<SplideSlide>
								<a href={item?.url_mobile} aria-label="pop up">
									<img class="w-full" src={img?.path} alt={img?.path} loading="lazy" />
								</a>
							</SplideSlide>
						{/each}
					{/each}
				</Splide>
			</div>
		</div>
	</div>
{/if}
